import type { FC } from 'react';

import { Link, Small } from '../components';

const TermsLinks: FC<{ landingUrl: string }> = ({ landingUrl = '' }) => (
    <Small>
        By signing up, you accept our{' '}
        <Link href={`${landingUrl}/terms-of-service`} target="_blank" rel="noreferrer">
            Terms of Service
        </Link>{' '}
        and{' '}
        <Link href={`${landingUrl}/privacy-policy`} target="_blank" rel="noreferrer">
            Privacy Policy
        </Link>
        .
    </Small>
);

export default TermsLinks;
